import EditReviewBill from '../../../bills/components/EditReviewBill';

export default function EditReviewBillScreen() {
    return <EditReviewBill />;
}
